module.exports = __webpack_public_path__ + "img/filter-circle-dollar.ece4beb9.svg";